// extracted by mini-css-extract-plugin
export default {"addressLink":"Address_addressLink__3BLcc","addressIcon":"Address_addressIcon__ImHa6","textWrapper":"Address_textWrapper__w3OB8"};